import React from "react";
import { Member, Payment } from "../../types/types";
import { formatAmountForDisplay } from "../../utils/stripe-helpers";

type Props = {
  name: string;
  amount: number;
  min: number;
  max: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectTransferFeeFlag: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  payment: Payment;
  displayStopRadioButton?: boolean;
};

const CustomDonationInput = ({
  name,
  amount,
  min,
  max,
  onChange,
  selectTransferFeeFlag,
  className,
  payment,
  displayStopRadioButton = false,
}: Props) => (
  <>
    <div className="p-form__kifuPrice">
      <p className="p-form__label">寄付金額をお選びください</p>
      <div className="p-form__item -mt">
        <div className="p-form__input -radio2">
          <label>
            <input
              name="r2"
              type="radio"
              checked={
                [1000, 2000, 3000, 5000, 10000, 15000, 20000, 30000].indexOf(
                  Number(amount)
                ) >= 0
              }
            />
            <span>以下の選択肢から金額を選ぶ</span>
          </label>
        </div>
      </div>
      <div className="p-form__kifuPriceCols">
        <div className="p-form__kifuPriceColsCol">
          <div className="p-form__input -radio3">
            <label>
              <input
                name={name}
                type="radio"
                value={1000}
                checked={amount == 1000}
                onChange={onChange}
              />
              <span>¥1,000</span>
            </label>
          </div>
        </div>
        <div className="p-form__kifuPriceColsCol">
          <div className="p-form__input -radio3">
            <label>
              <input
                name={name}
                type="radio"
                value={2000}
                checked={amount == 2000}
                onChange={onChange}
              />
              <span>¥2,000</span>
            </label>
          </div>
        </div>
        <div className="p-form__kifuPriceColsCol">
          <div className="p-form__input -radio3">
            <label>
              <input
                name={name}
                type="radio"
                value={3000}
                checked={amount == 3000}
                onChange={onChange}
              />
              <span>¥3,000</span>
            </label>
          </div>
        </div>
        <div className="p-form__kifuPriceColsCol">
          <div className="p-form__input -radio3">
            <label>
              <input
                name={name}
                type="radio"
                value={5000}
                checked={amount == 5000}
                onChange={onChange}
              />
              <span>¥5,000</span>
            </label>
          </div>
        </div>
        <div className="p-form__kifuPriceColsCol">
          <div className="p-form__input -radio3">
            <label>
              <input
                name={name}
                type="radio"
                value={10000}
                checked={amount == 10000}
                onChange={onChange}
              />
              <span>¥10,000</span>
            </label>
          </div>
        </div>
        <div className="p-form__kifuPriceColsCol">
          <div className="p-form__input -radio3">
            <label>
              <input
                name={name}
                type="radio"
                value={15000}
                checked={amount == 15000}
                onChange={onChange}
              />
              <span>¥15,000</span>
            </label>
          </div>
        </div>
        <div className="p-form__kifuPriceColsCol">
          <div className="p-form__input -radio3">
            <label>
              <input
                name={name}
                type="radio"
                value={20000}
                checked={amount == 20000}
                onChange={onChange}
              />
              <span>¥20,000</span>
            </label>
          </div>
        </div>
        <div className="p-form__kifuPriceColsCol">
          <div className="p-form__input -radio3">
            <label>
              <input
                name={name}
                type="radio"
                value={30000}
                checked={amount == 30000}
                onChange={onChange}
              />
              <span>¥30,000</span>
            </label>
          </div>
        </div>
      </div>

      <div className="p-form__item -mt">
        <div className="p-form__input -radio2">
          <label>
            <input
              name="r2"
              type="radio"
              checked={
                [1000, 2000, 3000, 5000, 10000, 15000, 20000, 30000, 0].indexOf(
                  Number(amount)
                ) < 0
              }
            />
            <span>自由に金額を入力する（1,000円以上）</span>
          </label>
        </div>
      </div>

      <div className="p-form__kifuPriceInput">
        <div className="p-form__input">
          <input
            name={name}
            type="text"
            placeholder="¥2,000"
            value={amount}
            onChange={onChange}
          />
        </div>
      </div>
    </div>

    <div className="p-form__kifuCheck">
      <div className="p-form__input -checkbox">
        <label>
          <input
            type="checkbox"
            checked={payment.transfer_fee_flag}
            onChange={selectTransferFeeFlag}
          />
          <span>
            決済手数料3.6%+税（{Math.ceil(amount / 0.964 - amount)}
            円）を追加で負担して寄付する
          </span>
        </label>
      </div>
      <div className="p-form__kifuCheckTxt">
        <p>ご負担いただいた手数料分も含めた合計金額が寄付額とみなされます。</p>
      </div>
    </div>

    {displayStopRadioButton ? (
      <div className="p-form__kifuPrice">
        <div className="p-form__item -mt">
          <div className="p-form__input -radio2">
            <label>
              <input
                name={name}
                type="radio"
                value={0}
                checked={amount == 0}
                onChange={onChange}
              />
              <span>継続寄付を停止する</span>
            </label>
          </div>
        </div>
      </div>
    ) : (
      <></>
    )}
  </>
);

export default CustomDonationInput;
